import { Button, Chip, Grid, Paper, Typography } from '@material-ui/core';
// import EventNoteIcon from '@material-ui/icons/EventNote';
// import ScheduleIcon from '@material-ui/icons/Schedule';
// import moment from 'moment';
import clsx from 'clsx';
import React from 'react';
import Carousel from 'react-material-ui-carousel';

// import bgW from 'assets/images/imagotipo.svg';
// import ellipse from 'assets/images/ellipse.svg';
// import redDots from 'assets/images/red-dots.svg';

import useStyles from './styles';

/**
 * ComingCourseFeature component
 *
 * @returns {JSX.Element}
 */

interface IProps {
  resources: any[];
}

const FeaturedResource: React.FC<IProps> = ({ resources }): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container className={clsx(classes.root)}>
      {/* <div className={classes.backgroundAdornmentsSection}>
        <img src={bgW} alt="winwin" className={classes.backgroundWSection} />
        <img src={redDots} alt="winwin red dots" className={classes.backgroundRedDotsSection} />
        <img src={ellipse} alt="winwin ellipse" className={classes.backgroundEllipseSection} />
      </div> */}
      <Carousel
        autoPlay={true}
        navButtonsAlwaysVisible={true}
        animation="slide"
        indicators={false}
        className={classes.carousel}
      >
        {resources.map((resource: any, index: number) => (
          <Grid item className={classes.oneFullWidth} key={index}>
            <Grid item xs={12} md={6} className={classes.oneFullWidthLeft}>
              <Typography className={classes.detailsTextOneFullWidth}>
                {`${resource.category.charAt(0).toUpperCase() + resource.category.slice(1)} by ${
                  resource.author
                }`}
              </Typography>
              <Typography className={classes.titleOneFullWidth}>{resource.title}</Typography>
              <Grid key={index} className={classes.tagsGrid}>
                {resource.skills.map((skill: any, index: number) => (
                  <Chip key={index} label={skill.name} className={classes.tags} />
                ))}
              </Grid>
              {/* <Typography className={classes.detailsTextOneFullWidth}>
                <EventNoteIcon className={classes.icon} />{' '}
                {moment(resource.start).format('dddd DD MMMM YYYY ')}
                <ScheduleIcon className={classes.icon} />{' '}
                {`${moment(resource.start).format('hh:mm')} horas`}
              </Typography> */}
              <Button
                variant="contained"
                color="primary"
                className={classes.knowMoreButton}
                type="button"
                href={resource.url}
              >
                {/* <Link className={classes.linkButton} to={resource.url}> */}
                More info
                {/* </Link> */}
              </Button>
            </Grid>
            <Grid className={classes.oneFullWidthRight}>
              <Paper
                className={classes.oneFullWidthImage}
                style={{
                  backgroundImage: `url(${
                    resource.image.formats.medium
                      ? resource.image.formats.medium.url
                      : resource.image.url
                  })`,
                }}
              />
            </Grid>
          </Grid>
        ))}
      </Carousel>
    </Grid>
  );
};

export { FeaturedResource };
